var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusPurpleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0246 13.7059C21.4792 13.7059 21.8477 13.3374 21.8477 12.8828C21.8477 12.4283 21.4792 12.0598 21.0246 12.0598H13.6707V4.70587C13.6707 4.25132 13.3022 3.88283 12.8477 3.88283C12.3931 3.88283 12.0246 4.25132 12.0246 4.70587V12.0598H4.6707C4.21614 12.0598 3.84766 12.4283 3.84766 12.8828C3.84766 13.3374 4.21614 13.7059 4.6707 13.7059L12.0246 13.7059L12.0246 21.0598C12.0246 21.5143 12.3931 21.8828 12.8477 21.8828C13.3022 21.8828 13.6707 21.5143 13.6707 21.0598L13.6707 13.7059L21.0246 13.7059Z",
    fill: "#8438FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusPurpleIcon);
export default __webpack_public_path__ + "static/media/plus-purple-icon.b215d83c12d893e43b5f5a75679b59ef.svg";
export { ForwardRef as ReactComponent };